import {Subscription} from 'rxjs';
import {map} from 'rxjs/operators';
import {Galleries} from '../../../../config/config';
import {SwiperConfigInterface, SwiperDirective} from 'ngx-swiper-wrapper';
import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UtilsService} from '../../../providers/services/utils.service';
import {GalleryService} from '../../../providers/services/gallery.service';

@Component({
  selector: 'app-gallery-banner-homepage',
  templateUrl: './gallery-banner-homepage.component.html',
  styleUrls: ['./gallery-banner-homepage.component.scss']
})
export class GalleryBannerHomepageComponent implements OnInit, OnDestroy {

  @ViewChild(SwiperDirective, {static: false}) swiperInstance: SwiperDirective;

  private subscriptions: Subscription = new Subscription();
  public items;

  public readonly config: SwiperConfigInterface = {
    navigation: false,
    mousewheel: false,
  autoplay: {
      delay: 5000
      },
  };

  constructor(private utilsService: UtilsService, private galleryService: GalleryService) {
    if (this.utilsService.isPlatformBrowser) {
      this.subscriptions.add(
        this.galleryService.getGallery(Galleries.BannerHomepage)
          .pipe(map(res => res.body))
          .subscribe(({data}) => {
            this.items = data.gallery.pictures;

            if (this.swiperInstance) {
              this.swiperInstance.update();
            }
          })
      );
    }
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}
